import React from 'react';
import FeeRow from './FeeRow';

const FeePlatformGroup = ({
  platform, rows, collapsed, onToggle, multiplier,
  isRowChanged, onChange, onToggleAvailable, onCopyClick,
}) => (
  <div className="mb-3">
    <button
      className="btn w-100 d-flex justify-content-between align-items-center px-3 py-2"
      style={{ backgroundColor: '#072040', color: '#fff', borderRadius: collapsed ? '4px' : '4px 4px 0 0' }}
      onClick={onToggle}
    >
      <span className="fw-semibold">
        {platform}
        <span className="badge ms-2" style={{ backgroundColor: '#599BE3' }}>
          {rows.length} portfolio{rows.length === 1 ? '' : 's'}
        </span>
      </span>
      <span>{collapsed ? '▸' : '▾'}</span>
    </button>

    {!collapsed && (
      <div className="table-responsive border border-top-0" style={{ borderColor: '#003366' }}>
        <table className="table table-sm table-hover align-middle mb-0" style={{ fontSize: '0.85rem' }}>
          <thead>
            <tr style={{ backgroundColor: '#072040', color: '#fff' }}>
              <th>Code</th>
              <th>Name</th>
              <th>Risk</th>
              <th>Master SAA</th>
              <th>PDS Date</th>
              <th>Mgmt Fee</th>
              <th>Sub-Portfolio Fee</th>
              <th>Indirect Costs</th>
              <th>Rebates</th>
              <th style={{ backgroundColor: '#E7E6E6', color: '#212529' }}>Total Fixed</th>
              <th>Txn Fees</th>
              <th>Perf Fees</th>
              <th style={{ backgroundColor: '#E7E6E6', color: '#212529' }}>Total Variable</th>
              <th>Available</th>
              <th>Last Updated</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {rows.map(row => (
              <FeeRow
                key={row.portfolio_code}
                row={row}
                changed={isRowChanged(row)}
                multiplier={multiplier}
                onChange={onChange}
                onToggleAvailable={onToggleAvailable}
                onCopyClick={onCopyClick}
              />
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
);

export default FeePlatformGroup;
